export function deleteChat(chatProtocol) {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append(
    "Authorization",
    `Basic ${process.env.REACT_APP_HISTORIC_KEY}`
  );

  const raw = JSON.stringify({
    protocol: `${chatProtocol}`,
  });

  const requestOptions = {
    method: "DELETE",
    headers: headers,
    body: raw,
    redirect: "follow",
  };

  return fetch(
    `${process.env.REACT_APP_TADEO_SERVICES_URL}/historic/chat/delete/`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Deleting chat endpoint's response was not ok");
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
}
